import React from "react";
import { DatePicker as RsuiteDatePicker } from "rsuite";

const DatePicker = ({
  title,
  error,
  onClick,
  value,
  data,
  isOnChange,
  name,
}) => {
  // eslint-disable-next-line
  const onChangeHandler = (e) => {
    if (isOnChange) {
      onchange("", e);
    }
  };
  return (
    <div className="input-container d-flex flex-column gap-column-1">
      <small>{title}</small>
      <RsuiteDatePicker
        size="xs"
        className={"input-width"}
        placeholder="YYYY-MM-DD"
        appearance="subtle"
        value={value}
        data={data}
        readOnly
        oneTap
        //readOnly={isOnChange}
        onClick={/* isOnChange &&  */onClick}
        //onChange={!isOnChange && onChangeHandler}
      />
      {error && <small className="error-message text-danger">{error}</small>}
    </div>
  );
};

export default DatePicker;
